define('root/audio_video/Podio.UI.AudioVideo.GTMFree',['require','lib/Podio.Transport','models/LiveModel'],function(require) {

  var transport = require('lib/Podio.Transport');
  var LiveModel = require('models/LiveModel');

  function create(conversationId) {
    var liveModel = new LiveModel({
      'provider': 'gtm_free',
      'ref_type': 'conversation',
      'ref_id': conversationId
    });
    liveModel.save().done(function() {
      open(liveModel, true);
    });
  }

  function getUrl(providerId) {
    return 'https://free.gotomeeting.com/{0}'.format(providerId);
  }

  function open(liveModel, monitor) {
    var url = getUrl(liveModel.get('provider_id'));

    var popup = window.open(url, '_blank');

    if (monitor) {
      monitorPopup(popup, liveModel);
    }
  }

  function monitorPopup(popup, liveModel) {
    if (popup.closed) {
      liveModel.destroy();
    } else {
      setTimeout(monitorPopup.curry(popup, liveModel), 1000);
    }
  }

  function accept(liveId) {
    var liveModel = new LiveModel({
      'live_id': liveId
    });
    liveModel.accept().done(function() {
      liveModel.fetch().done(function() {
        open(liveModel, false);
      });
    });
  }

  function reject(liveId) {
    var liveModel = new LiveModel({
      'live_id': liveId
    });
    liveModel.reject();
  }

  return {
    getUrl: getUrl,
    create: create,
    accept: accept,
    reject: reject
  };

});

